import { useAuth } from "@/context/AuthContext";
import NotificationDrawer from "@/components/layout/NotificationDrawer";
import { Building2, MapPin, LogOut } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function Navbar({ notifications, reloadNotifications }) {
  const { user, logout, isManagement } = useAuth();
  const initials = (user?.name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  const scope = isManagement ? "All Properties" : (user?.city_scope_label || (user?.cities || []).join(", ") || "Assigned Region");

  return (
    <header className="sticky top-0 z-40 h-16 border-b border-border bg-card/85 backdrop-blur-md">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 h-full flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-lg bg-primary text-primary-foreground grid place-items-center">
            <Building2 className="h-5 w-5" />
          </div>
          <div className="leading-none">
            <div className="font-serif text-lg font-semibold">Tamanna Hotels</div>
            <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-primary/80">Corporate Sales Portal</div>
          </div>
        </div>

        <div className="flex items-center gap-2 sm:gap-3">
          <span className={`hidden sm:inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full border font-medium ${
            isManagement ? "bg-primary/10 text-primary border-primary/30" : "bg-blue-50 text-blue-700 border-blue-200"
          }`} data-testid="role-badge">
            {isManagement ? "Management" : "Sales Executive"}
          </span>
          <span className="hidden md:inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full border border-border bg-secondary text-secondary-foreground" data-testid="scope-badge">
            <MapPin className="h-3.5 w-3.5 text-primary" /> {scope}
          </span>

          <NotificationDrawer notifications={notifications} reloadNotifications={reloadNotifications} />

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button className="h-9 w-9 rounded-full bg-[#0F172A] text-white grid place-items-center text-xs font-semibold font-mono hover:ring-2 hover:ring-primary/40 transition" data-testid="user-menu-button">
                {initials}
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-60">
              <DropdownMenuLabel>
                <div className="font-sans">{user?.name}</div>
                <div className="text-xs text-muted-foreground font-normal">{user?.email}</div>
                <div className="text-xs text-muted-foreground font-normal mt-0.5">{user?.title}</div>
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={() => logout()} data-testid="logout-button" className="text-destructive focus:text-destructive">
                <LogOut className="h-4 w-4 mr-2" /> Sign out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}
